export const OrderEntryURLS = {
    newSsReissueView: '/newSsReissue',
    orderEntryBatchView: '/orderEntry/:batchId'
}